"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var xstream_1 = require("xstream");
var adapt_1 = require("@cycle/run/lib/adapt");
function makePeriodic(schedule, currentTime) {
    return function periodic(period) {
        var stopped = false;
        function scheduleNextEvent(entry, time, schedule, currentTime) {
            if (stopped) {
                return;
            }
            var value = entry.value + 1;
            schedule.next(entry.stream, currentTime() + period, value, scheduleNextEvent);
        }
        ;
        var producer = {
            listener: null,
            start: function (listener) {
                producer.listener = listener;
                schedule.next(listener, currentTime() + period, 0, scheduleNextEvent);
            },
            stop: function () {
                stopped = true;
                schedule.completion(producer.listener, currentTime());
            }
        };
        return adapt_1.adapt(xstream_1.default.create(producer));
    };
}
exports.makePeriodic = makePeriodic;



//////////////////
// WEBPACK FOOTER
// /Users/Fuunnx/workspace/zygmund/~/@cycle/time/dist/periodic.js
// module id = ../../../node_modules/@cycle/time/dist/periodic.js
// module chunks = 1